import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiServiceUtils} from './api-service-utils';
import {Observable} from 'rxjs';
import {shareReplay, tap} from 'rxjs/operators';
import * as _ from 'lodash';

@Injectable({providedIn: 'root'})
export class UsersService {
  constructor(private apiServiceUtils: ApiServiceUtils, private http: HttpClient) {}

  usersUrl = '/users';

  /** Shared in-flight + completed currentUser request. */
  private currentUserRequest$: Observable<any> | null = null;

  /** Per-role cache for findUsersByRole (prgl, reviewer, etc.). */
  private usersByRoleRequests = new Map<string, Observable<any>>();

  public findCurrentUser() {
    if (!this.currentUserRequest$) {
      this.currentUserRequest$ = this.http.get(`${this.apiServiceUtils.getApiUrl()}${this.usersUrl}/currentUser`).pipe(
        tap({
          error: () => {
            this.currentUserRequest$ = null;
          }
        }),
        shareReplay(1)
      );
    }
    return this.currentUserRequest$;
  }

  public clearCurrentUserCache() {
    this.currentUserRequest$ = null;
  }

  public findUsersByRole(role) {
    const key = (role || '').toString();
    if (!this.usersByRoleRequests.has(key)) {
      this.usersByRoleRequests.set(
        key,
        this.http.get(`${this.apiServiceUtils.getApiUrl()}${this.usersUrl}/${role}`).pipe(
          tap({
            error: () => {
              this.usersByRoleRequests.delete(key);
            }
          }),
          shareReplay(1)
        )
      );
    }
    return this.usersByRoleRequests.get(key);
  }

  public clearUsersByRoleCache(role?: string) {
    if (role != null) {
      this.usersByRoleRequests.delete(role.toString());
    } else {
      this.usersByRoleRequests.clear();
    }
  }

  public authorizeUser(user) {
    return this.http.post(`${this.apiServiceUtils.getApiUrl()}/externalUser/authorize`, user);
  }
}
